import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { Button as UnstyledButton } from 'src/components/button'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'
import { rgbaStrOpacity } from 'src/utils/colors'
import chroma from 'chroma-js'

export const Button = styled(UnstyledButton)`
  padding: 8px 24px;
  font-size: 14px;
  color: ${Colors.textWhite};
`

export const NavigationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${Shapes.spacing[5]}px;
`

export const BackButton = styled(ButtonWithIcon)`
  position: absolute;
  top: ${Shapes.spacing[4]}px;
  left: ${Shapes.spacing[4]}px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`

export const HeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
`

export const TitleAndSubtitleWrapper = styled.div`
  flex: 1;
`

export const TitleAndActionButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${Shapes.spacing[2]}px;

  &:last-of-type {
    margin-bottom: 0px;
  }
`

export const ActionButtonsWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
`

export const RightActionButtons = styled.div`
  display: flex;
  gap: 8px;
`

export const Title = styled.span`
  display: block;
  font-size: 18px;
  margin-right: ${Shapes.spacing[3]}px;
`

export const Subtitle = styled.span`
  display: block;
  font-size: 13px;
  opacity: 0.8;
`

export const UserListsWrapper = styled.div`
  margin-top: 16px;
`

export const ListItemWrapper = styled.div<{ disabled?: 1 | 0 }>`
  cursor: pointer;
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px 16px;
  border-radius: ${Shapes.borderRadius}px;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  &:hover {
    background-color: ${(props) => (props.disabled ? 'transparent' : Colors.userListItemBackgroundHover)};
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }
`

export const ListItemIconWrapper = styled.div`
  display: flex;
`

export const ListItemName = styled.div`
  flex: 1;
`

export const ListItemDescription = styled.div`
  flex: 1;
  color: ${Colors.textLight};
`

export const DeleteActionWrapper = styled.div`
  pointer-events: none;
  display: flex;
  padding: 4px;
  opacity: 0;

  ${ListItemWrapper}:hover & {
    pointer-events: all;
    opacity: 1;
  }
`

export const DenseButton = styled(ButtonWithIcon)`
  background-color: transparent;
  border-color: ${(props) => rgbaStrOpacity(props.color || Colors.textWhite, 0.2)};
  &:hover {
    background-color: ${(props) =>
      props.color ? chroma(props.color).alpha(0.05).hex() : rgbaStrOpacity(Colors.textWhite, 0.05)};
  }
  &:disabled {
    svg {
      opacity: 0.5;
      fill: ${Colors.textLight} !important;
      color: ${Colors.textLight} !important;
    }
  }
`
